import { render, staticRenderFns } from "./MemoDeals.vue?vue&type=template&id=b3e016dc&scoped=true&"
import script from "./MemoDeals.vue?vue&type=script&lang=js&"
export * from "./MemoDeals.vue?vue&type=script&lang=js&"
import style0 from "./MemoDeals.vue?vue&type=style&index=0&id=b3e016dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e016dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3e016dc')) {
      api.createRecord('b3e016dc', component.options)
    } else {
      api.reload('b3e016dc', component.options)
    }
    module.hot.accept("./MemoDeals.vue?vue&type=template&id=b3e016dc&scoped=true&", function () {
      api.rerender('b3e016dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projects/MemoDeals.vue"
export default component.exports